import { trpc } from 'api'
import { useRemoteConfig } from 'hooks/useRemoteConfigStore'
import { useStore } from 'hooks/useSession'

export const useStaffList = () => {
  const store = useStore()
  const config = useRemoteConfig()
  const staff = trpc.staff.list.useQuery(
    {
      storeId: store?.id || '',
      roles: config?.region.prescriptionRoles || ['OPTOMETRIST'],
    },
    {
      enabled: !!store,
    }
  )
  return staff
}
